import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'src/containers/contexts/auth-provider';
import { useUserStore } from 'src/store/user-store';
import { useAvailableSites } from './api/use-available-sites';

type ReturnType = {
  siteContext: boolean;
};

export const useSetViewContext = (): ReturnType => {
  const { viewContext, setViewContext, setIsLoadingViewContextAccess } =
    useUserStore();

  const auth = useAuth();
  const navigate = useNavigate();

  const [access, setAccess] = useState({
    siteContext: false,
  });

  const [hasFetchedAccess, setHasFetchedAccess] = useState(false);

  const availableSites = useAvailableSites(!!auth.session?.access_token);

  useEffect(() => {
    if (availableSites.isSuccess && availableSites.data?.resources.length > 0) {
      setAccess(prev => ({
        ...prev,
        siteContext: true,
      }));
    }

    if (
      availableSites.isError ||
      (!availableSites.isPending && availableSites.data?.resources.length === 0)
    ) {
      setAccess(prev => ({
        ...prev,
        siteContext: false,
      }));
    }
  }, [
    availableSites.isSuccess,
    availableSites.isError,
    availableSites.data?.resources.length,
    availableSites.isPending,
  ]);

  useEffect(() => {
    if (availableSites.isSuccess || availableSites.isError) {
      setHasFetchedAccess(true);
    }
  }, [availableSites.isError, availableSites.isSuccess]);

  useEffect(() => {
    if (hasFetchedAccess) {
      switch (true) {
        case access.siteContext && viewContext === null:
          setViewContext('site');
          setIsLoadingViewContextAccess(false);
          navigate('/');

          break;

        default:
          setIsLoadingViewContextAccess(false);
          break;
      }
    }
  }, [
    access.siteContext,
    navigate,
    setIsLoadingViewContextAccess,
    setViewContext,
    viewContext,
    hasFetchedAccess,
  ]);

  return access;
};
